<template>
  <div>
    <v-layout row justify-center>
      <v-dialog v-model="classdialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar color="info" size="120px" dark>
              <v-toolbar-title class="baslikfont">{{classdialog_baslik}}</v-toolbar-title>

            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout row="" wrap>
                <div class="flex md12">
                  <v-text-field label="Class Adı" mask="N" :color="color" v-model="classadi" :error-messages="errors.collect('classadi1')"
                    v-validate="'required'" data-vv-name="classadi1" required>
                  </v-text-field>
                </div>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="classdialog=false">Vazgeç</v-btn>
            <v-btn id="bkaydet" color="blue darken-1" flat @click.native="ClassKaydet()">Kaydet</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="parkurdialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar color="info" size="120px" dark>
              <v-toolbar-title class="baslikfont">{{parkurdialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout row="" wrap>
                <div class="flex md12">
                  <v-text-field v-if="parkaybtn" label="Parkur Kodu" mask="NNN" :color="color" v-model="Parkur.ParkurKod"
                    :error-messages="errors.collect('parkurkod')" v-validate="'required'" data-vv-name="parkurkod"
                    required>
                  </v-text-field>
                  <v-text-field label="Açıklama" :color="color" v-model="Parkur.Aciklama">
                  </v-text-field>
                </div>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="parkurdialog=false">Vazgeç</v-btn>
            <v-btn v-if="pargncbtn" color="blue darken-1" flat @click="ParkurKaydet()">Güncelle</v-btn>
            <v-btn v-if="parkaybtn" color="blue darken-1" flat @click="ParkurKaydet()">Kaydet</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


      <v-dialog v-model="havayoludialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar color="info" size="120px" dark>
              <v-toolbar-title class="baslikfont">{{havayoludialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout row="" wrap>
                <div class="flex md12">
                  <v-layout>
                    <v-text-field hide-details=""  label="Hava Yolu Kodu" mask="NNN" :color="color" v-model="havayolu.HavaYoluKodu"
                      :error-messages="errors.collect('hyolukod')" v-validate="'required'" data-vv-name="hyolukod"
                      required>
                    </v-text-field>
                    <v-text-field label="Form No" hide-details="" v-model="havayolu.FormNo" :color="color">
                    </v-text-field>
                  </v-layout>
                  <v-text-field label="Hava Yolu Açıklama" hide-details="" :color="color" v-model="havayolu.HavaYoluAdi">
                  </v-text-field>
                  <v-layout>

                    <yuzdeinput :etiket="'İç Hat %'"  :tabdeger="0" v-model="havayolu.IchatYuzde1" :autocomplete="'autocomplete'"></yuzdeinput>
                    <yuzdeinput :etiket="'Dış Hat %'" :tabdeger="0" v-model="havayolu.DishatYuzde1" :autocomplete="'autocomplete'"></yuzdeinput>
                  </v-layout>
                  <v-layout>
                    <v-text-field hide-details="" label="İç Hat Muh. Kodu" :color="color" v-model="havayolu.MuhasebeKodlari.IchatMuhKodu"></v-text-field>
                    <v-text-field hide-details="" label="Dış Hat Muh. Kodu" :color="color" v-model="havayolu.MuhasebeKodlari.DishatMuhKodu"></v-text-field>
                  </v-layout>
                   <v-autocomplete hide-details=""  clearable="" label="Cari Hesap Kodu" append-icon="search"
                      :loading="loading" :items="statecari" item-text="text" cache-items="" item-value="id" v-model="havayolu.Cari.Kod"
                      :search-input.sync="searchcari"></v-autocomplete>
                  <v-select hide-details="" v-model="havayolu.Doviz.DovizKod" :items="doviztipi" clearable item-text="DovizUnvan" item-value="DovizKod"
                    label="Döviz Tipi"></v-select>
                    <v-layout>
                  <v-text-field hide-details="" label="GSA Brüt/Net" :color="color" ></v-text-field>

                  <v-text-field hide-details="" label="Hava Yolu Kontrolü" :color="color" v-model="havayolu.HavayoluKontrolu"></v-text-field>
                    </v-layout>
                  <v-layout>
                    <v-autocomplete hide-details="" :items="bankapositems"  v-model="havayolu.HavaYoluPosKodu" item-text="Aciklama" item-value="PosKodu"
                      clearable label="Pos Kodu"></v-autocomplete>
                    <v-autocomplete :items="bankapositems" hide-details="" item-text="Aciklama" item-value="PosKodu"
                      clearable v-model="havayolu.MuhasebeKodlari.HavayoluPosMuhasebeKodu" label="Muhasebe Pos Kodu"></v-autocomplete>
                  </v-layout>
                  <v-layout>
                  <v-checkbox hide-details="" label="GSA" value="1" v-model="havayolu.GSA" ></v-checkbox>
                   <v-checkbox hide-details="" label="Cari Hesabı Var" value="1" v-model="havayolu.Carimi" ></v-checkbox>
                  </v-layout>
                  <v-checkbox hide-details="" label="Servis Ücretini Hava Yolu Alır" value="1" v-model="havayolu.ServisUcreti" ></v-checkbox>

                  <v-checkbox hide-details="" label="Parametreden Gelen YFF Sıfırlanır" value="1" v-model="havayolu.YffSifir" ></v-checkbox>


                </div>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="havayoludialog=false">Vazgeç</v-btn>
            <v-btn v-if="pargncbtn" color="blue darken-1" flat @click="HavaYoluKaydet()">Güncelle</v-btn>
            <v-btn v-if="parkaybtn" color="blue darken-1" flat @click="HavaYoluKaydet()">Kaydet</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


    </v-layout>
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title class="baslikfont">Hava Yolu/Parkur/Class Tanımlama </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-layout>

    <v-container fluid="">
      <v-layout row wrap>

        <div class="flex md5">
          <v-toolbar size="120px" dark color="info">
            <v-icon dark>flight</v-icon>
            <v-toolbar-title class="baslikfont">Hava Yolu</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="havayoluekle()" class="white--text" flat>
              <v-icon medium="" right dark>add_box</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card>
            <v-card-title>
              <v-spacer></v-spacer>

              <div class="flex md12">
                <v-text-field append-icon="search" label="Kayıtlar içinde arama" single-line hide-details v-model="search1"
                  id="datatable">
                </v-text-field>
              </div>
            </v-card-title>
            <v-data-table :headers="headers1" :loading="progress" :rows-per-page-items=[10,100] :items="items" :search="search1">
              <v-progress-linear slot="progress" indeterminate></v-progress-linear>

              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.HavaYoluKodu }}</td>
                <td class="text-xs-left">{{ props.item.FormNo }}</td>
                <td class="text-xs-left">{{ props.item.HavaYoluAdi }}</td>
                <td class="justify-center layout px-0">
                  <v-icon @click="havayolugetir(props.item)"> edit </v-icon>
                  <v-icon @click="havayolusilsor(props.item)"> delete</v-icon>
                </td>
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Aradığınız "{{ search1 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
              </v-alert>
            </v-data-table>
          </v-card>
        </div>


        <div class="flex md5">
          <v-toolbar size="120px" dark color="info">


            <v-icon dark>flight_takeoff</v-icon>
            <v-toolbar-title class="baslikfont">Parkur</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="parkurekle()" class="white--text" flat>
              <v-icon medium="" right dark>add_box</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card>
            <v-card-title>

              <div class="flex md12">
                <v-text-field append-icon="search" label="Kayıtlar içinde arama" single-line hide-details v-model="search2"
                  id="datatable">
                </v-text-field>
              </div>
            </v-card-title>
            <v-data-table :headers="headers2" :loading="progress" :rows-per-page-items=[10,100] :items="itemsparkur"
              :search="search2">
              <v-progress-linear slot="progress" indeterminate></v-progress-linear>

              <template slot="items" slot-scope="props">

                <td class="text-xs-left">{{ props.item.ParkurKod }}</td>
                <td class="text-xs-left">{{ props.item.Aciklama }}</td>
                <v-icon class="mr-2" @click="parkurgetir(props.item)"> edit </v-icon>
                <v-icon @click="parkursilsor(props.item.ParkurKod)"> delete</v-icon>

              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Aradığınız "{{ search2 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
              </v-alert>
            </v-data-table>
          </v-card>
        </div>


        <div class="flex md2">

          <v-toolbar size="120px" dark color="info">
            <v-icon dark>view_list</v-icon>
            <v-toolbar-title class="baslikfont">Class</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="classekle()" class="white--text" flat>
              <v-icon medium="" right dark>add_box</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card>
            <v-card-title>
              <v-spacer></v-spacer>

              <div class="flex md12">
                <v-text-field append-icon="search" label="Ara" single-line hide-details v-model="search3" id="datatable">
                </v-text-field>
              </div>
            </v-card-title>
            <v-data-table :headers="headers3" :loading="progress" :rows-per-page-items=[10,100] :items="classitems"
              :search="search3">
              <v-progress-linear slot="progress" indeterminate></v-progress-linear>

              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.ClassAdi }}</td>
                <v-icon @click="classsilsor(props.item.ClassAdi)"> delete</v-icon>
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
              </v-alert>
            </v-data-table>
          </v-card>
        </div>


      </v-layout>
    </v-container>

    <v-dialog v-model="dialogkisamesaj" width="500">

      <v-card>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>Uyarı!</v-toolbar-title>
          </v-toolbar>
        </v-flex>

        <v-card-text>
          {{this.kisamesaj}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialogkisamesaj=false">
            iptal
          </v-btn>
          <v-btn v-if="clsok" color="primary" flat @click="ClassSil()">
            Tamam
          </v-btn>
          <v-btn v-if="parok" color="primary" flat @click="ParkurSil()">
            Tamam
          </v-btn>
          <v-btn v-if="hyoluok" color="primary" flat @click="HavaYoluSil()">
            Tamam
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>


    <template>

      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
          :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>
      <v-dialog v-model="dialog1" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Uyarı !</v-card-title>
          <v-card-text>{{dialogmessage1}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click.native="dialog1=false">Tamam</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import faturalistesiVue from '../faturalar/faturalistesi.vue';
  import yuzdeinput from '../customcomp/yuzdeinput'
import havayollaricompVue from './partpage/havayollaricomp.vue';


  export default {
    data() {
      return {
        headers1: [{
            text: 'Kod',
            value: 'HavaYoluKodu'
          },
          {
            text: 'Form No',
            value: 'FormNo'
          },
          {
            text: 'Aciklama',
            value: 'HavaYoluAdi'
          }
        ],
        headers2: [{
            text: 'Parkur Kodu',
            value: 'ParkurKod'
          },
          {
            text: 'Açıklama',
            value: 'Aciklama'
          }
        ],

        headers3: [{
          text: 'Class Adı',
          value: 'ClassAdi'
        }],

        havayolu: {
          HavaYoluTitle: null,
          HavaYoluKodu: null,
          FormNo: null,
          HavaYoluAdi: null,
          GSA: '0',
          IchatYuzde1: 0,
          IchatYuzde2: 0,
          DishatYuzde1: 0,
          DishatYuzde2: 0,
          Doviz: {
            DovizKod: null
          },
          Komisyon: null,
          Carimi: '0',
          HavayoluKontrolu: 'E',
          ServisUcreti: '0',
          YffSifir: '0',
          HavaYoluPosKodu: null,
          Cari: {
            Kod: null
          },
             MuhasebeKodlari: {
          IchatMuhKodu:null,
       DishatMuhKodu:null,
       HavayoluPosMuhasebeKodu:null
              }
        },
statecari:[],
searchcari:null,
        doviztipi: [],
        denemedeger: 0,
        silinecekkayit: null,
        classdialog: false,
        classdialog_baslik: null,
        classadi: null,
        parkurdialog: false,
        parkurdialog_baslik: null,
        havayoludialog: false,
        havayoludialog_baslik: null,

        pargncbtn: false,

        parkaybtn: false,


        loading: false,
        color: 'info',
        yedeksirket: [],
        itemsparkur: [],
        bankapositems: [],
        classitems: [],
        items: [],
        search3: '',
        search1: '',
        search2: '',
        search: null,
        select: [],
        selected: '',
        m: false,
        k: false,
        dialog: false,
        dialog1: false,
        dialogmessage1: '',
        Parkur: {
          ParkurKod: '',
          Aciklama: '',
        },
        state: [],
        yenisirket: {
          id: '',
          text: '',
          unvan: ''
        },
        hyoluok: false,
        parok: false,
        clsok: false,
        dialogkisamesaj: false,
        kisamesaj: null,
        dialog_baslik: '',
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text: '',
        text1: '',
        bankakod: '',
        bankaadi: '',
        progress: false,
        dictionary: {
          custom: {
            classadi1: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            parkurkod: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            hyolukod: {
              required: () => 'Bu alan boş bırakılamaz',
            }
          }
        }
      }
    },
    watch: {
      search(val) {
        val && this.carigetir(val)
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      parkursilsor(mesaj) {
        this.clsok = false
        this.parok = true
        this.hyoluok = false
        this.silinecekkayit = mesaj
        this.kisamesaj = "Parkur'u silmek istediğinize emin misiniz?"
        this.dialogkisamesaj = true
      },
      parkurgetir(kayit) {
        this.parkaybtn = false
        this.pargncbtn = true
        this.parkurdialog = true
        this.parkurdialog_baslik = "Parkur Düzenle"
        this.Parkur = kayit
      },
       havayolugetir(kayit) {
        this.parkaybtn = false
        this.pargncbtn = true
        this.havayoludialog = true
        this.havayoludialog_baslik = "Havayolu Düzenle"

        var seciliitems = [{
          text: kayit.Cari.Kod + '-' + kayit.Cari.Unvan,
          id: kayit.Cari.Kod
        }]
        this.statecari=seciliitems
        this.havayolu = kayit
      },
       havayolusilsor(mesaj) {
        this.clsok = false
        this.parok = false
        this.hyoluok= true
 this.havayolu=mesaj
        this.kisamesaj = "Havayolu'nu silmek istediğinize emin misiniz?"
        this.dialogkisamesaj = true
      },
      classsilsor(mesaj) {
        this.clsok = true
        this.parok = false
        this.hyoluok = false
        this.silinecekkayit = mesaj
        this.kisamesaj = "Class'ı silmek istediğinize emin misiniz?"
        this.dialogkisamesaj = true
      },
      classekle() {
        this.classdialog = true
        this.classdialog_baslik = "Class Ekle"
      },
      parkurekle() {
        this.Parkur.ParkurKod = null
        this.pargncbtn = false
        this.parkaybtn = true
        this.Parkur.Aciklama = null
        this.parkurdialog = true
        this.parkurdialog_baslik = "Parkur Ekle"
      },
      havayoluekle() {
        this.pargncbtn = false
        this.parkaybtn = true
        this.havayoludialog = true
        this.havayoludialog_baslik = "Hava Yolu Ekle"
      },

      deletesirket: deletesirket,
      sirketekle: sirketekle,
      ClassKaydet: ClassKaydet,
      ClassSil: ClassSil,
      ParkurSil: ParkurSil,
      HavaYoluSil:HavaYoluSil,
      ParkurKaydet: ParkurKaydet,
      guncelle: guncelle,
      carigetir:carigetir,
      HavaYoluKaydet:HavaYoluKaydet
    },
    beforeMount: beforeMount,
      watch: {
      searchcari(val) {
        val && this.carigetir(val)
      }
    },
    components: {
      'yuzdeinput': yuzdeinput
    },

  }

 function carigetir(v) {
    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }


function HavaYoluKaydet() {

  this.$validator.validateAll().then((result) => {
      if (result) {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = this.havayolu
    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineAdd', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.text1 = response.body.ResponseMessage
      this.snackbar = true

      if (response.body.Status == true) {
        this.havayoludialog = false
        var params1 = {
          CompanyCode: credentials.SirketKodu
        }
        this.classdialog = false
        this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          }
        })
}

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      }
    })

     }


    })

  }
  function ParkurKaydet() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = this.Parkur
    this.$http.post(auth.API_URL + 'api/TicketDefinitons/ParkurAdd', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.text1 = response.body.ResponseMessage
      this.snackbar = true

      if (response.body.Status == true) {
        this.parkurdialog = false
        var params1 = {
          CompanyCode: credentials.SirketKodu
        }
        this.classdialog = false
        this.$http.post(auth.API_URL + 'api/TicketDefinitons/ParkurList', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.itemsparkur = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          }
        })

      }



    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      }
    })

  }


  function ClassKaydet() {

    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
          CompanyCode: credentials.SirketKodu,
          ClassAdi: this.classadi,
        }
        this.$http.post(auth.API_URL + 'api/TicketDefinitons/ClassAdd', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true

          if (response.body.Status == true) {

            this.classdialog = false
            this.$http.post(auth.API_URL + 'api/TicketDefinitons/ClassList', params, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.classitems = response.body
              this.progress = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.progress = false

                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable'
                this.progress = false

                this.snackbar = true
              }
            })

          }



        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable.'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable.'
            this.snackbar = true
          }
        })
      }
    })
  }

  function ClassSil() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu,
      Code: this.silinecekkayit,
    }
    this.$http.post(auth.API_URL + 'api/TicketDefinitons/ClassDelete', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.text1 = response.body.ResponseMessage
      this.snackbar = true
      this.dialogkisamesaj = false


      if (response.body.Status == true) {

        this.$http.post(auth.API_URL + 'api/TicketDefinitons/ClassList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.classitems = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          }
        })

      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      }
    })

  }


  function ParkurSil() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu,
      Code: this.silinecekkayit,
    }
    this.$http.post(auth.API_URL + 'api/TicketDefinitons/ParkurDelete', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.text1 = response.body.ResponseMessage
      this.snackbar = true
      this.dialogkisamesaj = false


      if (response.body.Status == true) {

        var params1 = {
          CompanyCode: credentials.SirketKodu

        }

        this.$http.post(auth.API_URL + 'api/TicketDefinitons/ParkurList', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.itemsparkur = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          }
        })

      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      }
    })

  }



  function HavaYoluSil() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
Code:this.havayolu.HavaYoluKodu,
FormNo:this.havayolu.FormNo
    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineDelete', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.text1 = response.body.ResponseMessage
      this.snackbar = true
this.dialogkisamesaj=false

      if (response.body.Status == true) {

        var params1 = {
          CompanyCode: credentials.SirketKodu

        }

        this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })

      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      }
    })

  }



  function sirketekle() {

    this.dialog = true
    this.Sirket = {}
    this.dialog_baslik = 'Şirket Ekle'
    this.m = false
    this.k = true
    this.codegorunum = true
    this.$validator.reset()

  }

  function beforeMount() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu,
    }
    this.progress = true

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/ParkurList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsparkur = response.body
      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false
        this.snackbar = true
      }
    })




    this.$http.post(auth.API_URL + 'api/currency/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      }
    })



    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body
      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      }
    })
    this.$http.post(auth.API_URL + 'api/TicketDefinitons/ClassList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.classitems = response.body
      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      }
    })


    this.$http.post(auth.API_URL + 'api/BankPos/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.bankapositems = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-bankpos'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-bankpos'
        this.snackbar = true
      }
    })





  }

  function deletesirket() {

    if (window.confirm('Şirket\'i silmek istediğinizden eminmisiniz?')) {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      if (credentials.SirketKodu != this.Sirket.CompanyCode) {
        var params = this.Sirket
        var silinensirket = this.Sirket.CompanyCode
        this.$http.post(auth.API_URL + '/api/Company/Delete', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true

            //sirketleri güncelleyelim.
            var yedeksirket = []
            yedeksirket = credentials.Sirketler
            credentials.Sirketler = []

            for (let index = 0; index < yedeksirket.length; index++) {
              if (yedeksirket[index].id != silinensirket) {
                const element = yedeksirket[index];
                credentials.Sirketler.push(element)
              }
              window.localStorage.setItem('credentials', JSON.stringify(credentials));
            }

            location.reload();
            var params1 = {
              CompanyCode: credentials.SirketKodu,
            }

            this.$http.post(auth.API_URL + 'api/Company/List', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }


            }).then((response) => {
              this.items = response.body
              this.dialog = false

            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable-List'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable-List'
                this.snackbar = true
              }
            })

          } else {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          } else {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          }
        })

      } else {
        this.dialogmessage1 =
          'Silmek istediğiniz şirket şuan aktif olan şirkettir, lütfen şirket değişikliği yaptıktan sonra tekrar deneyiniz.'
        this.dialog1 = true

      }

    }


  }

  function guncelle() {
    this.$validator.validateAll().then((result) => {
      if (result) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        if (credentials.SirketKodu != this.Sirket.CompanyCode) {
          var params = this.Sirket
          this.codegorunum = false
          this.$http.post(auth.API_URL + 'api/Company/Update', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            if (response.body.Status) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
              this.yenisirket.id = this.Sirket.CompanyCode
              this.yenisirket.text = this.Sirket.CompanyName
              this.yenisirket.unvan = this.Sirket.CompanyTitle

              var yedeksirket = credentials.Sirketler;
              credentials.Sirketler = [];

              for (let index = 0; index < yedeksirket.length; index++) {
                const element = yedeksirket[index];
                if (this.yenisirket.id != yedeksirket[index].id) {
                  credentials.Sirketler.push(element)
                } else {
                  credentials.Sirketler.push(this.yenisirket);
                }
              }
              window.localStorage.setItem('credentials', JSON.stringify(credentials))
              location.reload();
            } else {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            }
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = response.statusText
              this.snackbar = true
            }
          })

        } else {
          this.dialogmessage1 =
            'Güncellemek istediğiniz şirket şuan aktif olan şirkettir, lütfen şirket değişikliği yaptıktan sonra tekrar deneyiniz.'
          this.dialog1 = true
        }

      }
    })
  }
</script>

<style>
  @import '../../../assets/css/custom.css';
</style>